var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignout = function SvgSignout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.484 23h13.032c.827 0 1.484-.674 1.484-1.484V8.484C24 7.658 23.326 7 22.516 7H9.484C8.658 7 8 7.674 8 8.484v13.032C8 22.326 8.674 23 9.484 23ZM14.76 9.698h6.204v10.588h-6.204v-3.271h1.248v2.023h3.726v-8.093h-3.726v2.023H14.76v-3.27Zm-1.888 2.242.876.877-1.55 1.55h5.765v1.248h-5.732l1.517 1.518-.877.877-3.034-3.035 3.035-3.035Z",
    fill: "#1D352A",
    fillOpacity: 0.5
  })));
};
export default SvgSignout;